export default __webpack_public_path__ + "media/Fisheye_left.b8b86a2ec0b753e23c28bf70a0f5153c.svg";